export function buildResultsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, viewDefId: string | null, weightsSetId: number | null, scoringSurveyId: number | null, scoringProjectUserId: number | null)
{
	return {
		'$type': 'TCh.Domain.Evaluation.ValueAnalysis.Queries.ResultsPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'ViewDefId': viewDefId,
		'WeightsSetId': weightsSetId,
		'ScoringSurveyId': scoringSurveyId,
		'ScoringProjectUserId': scoringProjectUserId
	}
}

export function buildScoringPanelistsBySurveyIdQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.ValueAnalysis.Queries.ScoringPanelistsBySurveyIdQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}
